
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M14 0c7.7311 0 14 6.26889 14 14 0 7.7311-6.2689 14-14 14-7.73111 0-14-6.265-14-14S6.26889 0 14 0Z","fill":"#26A17B"}}),_c('path',{attrs:{"d":"M15.971 12.4389v-2.0844h4.7638V7.18115H7.7654v3.17335h4.7639v2.0844c-3.86945.1789-6.78223.945-6.78223 1.8628 0 .9178 2.91278 1.6839 6.78223 1.8628v6.6694h3.4455v-6.6694c3.8656-.1789 6.7706-.945 6.7706-1.8628-.0039-.9178-2.9089-1.6839-6.7744-1.8628Zm.0038 3.1617c-.0972.0039-.595.035-1.7072.035-.8905 0-1.5128-.0233-1.7344-.035v.0039c-3.41835-.1517-5.97335-.7467-5.97335-1.4583 0-.7117 2.55111-1.3067 5.97335-1.4584v2.3178c.2255.0156.8633.0544 1.75.0544 1.0616 0 1.5944-.0427 1.6955-.0544V12.68c3.4145.1517 5.9617.7467 5.9617 1.4584-.0078.7116-2.555 1.3066-5.9656 1.4622Z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    